<script>
import {mapGetters} from 'vuex';
import ProjectChatbotModal from './ProjectChatbotModal.vue';

export default {
   name: 'ProjectsTable',
   components: {ProjectChatbotModal},

   computed: {
      ...mapGetters({
         isStaff: 'isStaff',
      }),

      projectsInStudy() {
         return this.$store.getters['projects/projectsInStudy'];
      },
   },

   methods: {
      showChat() {
         this.$refs.projectChatbotModal.show();
      },
   },
};
</script>

<template>
   <b-card class="mb-4 project-table" v-if="projectsInStudy.length > 0">
      <ProjectChatbotModal ref="projectChatbotModal" />
      <b-button
         v-if="!isStaff"
         @click="showChat()"
         variant="primary"
         class="project-table--button dark-button mb-2"
      >
         Add Project +
      </b-button>
      <div v-if="!projectsInStudy || projectsInStudy.length === 0">
         <b-spinner variant="primary" small class="mr-2"></b-spinner>
      </div>
      <div v-else>
         <h5 class="mb-3 project-table--title">Projects</h5>
         <b-table
            id="table-projects"
            small
            :fields="[{key: 'name', sortable: true}]"
            sort-by="name"
            :items="projectsInStudy"
            class="mb-3 project-table--content"
         >
         </b-table>
      </div>
   </b-card>
</template>

<style scoped lang="scss">
.project-table {
   &--button {
      width: 118px;
      height: 30px;
      background-color: #1660a9;
      font-size: 12px;
      font-weight: 400;
      position: absolute;
      right: 20px;
   }
   &--title {
      color: black;
      font-size: 16px;
      line-height: 30px;
   }
   &--content {
      font-size: 13px;
      border-top: 1px solid #e2e2e2;
      border-bottom: 1px solid #e2e2e2;
   }
}
</style>
